import { z } from 'zod';
import { APIFactoryOptions, factory } from '../../../config';

export const responseSchema = z.object({
	isProcessing: z.boolean(),
});

const getImportNetworkListStatus = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/network/import-status',
		method: 'GET',
		responseSchema,
	});

export default getImportNetworkListStatus;
